import FacebookPreview from "components/posts_previews/FacebookPreview";
import TwitterPreview from "components/posts_previews/TwitterPreview";
import MediumPreview from "components/posts_previews/MediumPreview";
import PinterestPreview from "components/posts_previews/PinterestPreview";
import TiktokPreview from "components/posts_previews/TiktokPreview";
import InstagramPreview from "components/posts_previews/InstagramPreview";
import LinkedinPreview from "components/posts_previews/LinkedinPreview";
import YoutubePreview from "components/posts_previews/YoutubePreview";
import ThreadsPreview from "components/posts_previews/ThreadsPreview";
import BlueskyPreview from "components/posts_previews/BlueskyPreview";

export default function getPreviewComponent(post) {
    if (post?.network === "twitter") return TwitterPreview;
    if (post?.network === "facebook") return FacebookPreview;
    if (post?.network === "medium") return MediumPreview;
    if (post?.network === "pinterest") return PinterestPreview;
    if (post?.network === "tiktok") return TiktokPreview;
    if (post?.network === "instagram") return InstagramPreview;
    if (post?.network === "linkedin") return LinkedinPreview;
    if (post?.network === "youtube") return YoutubePreview;
    if (post?.network === "threads") return ThreadsPreview;
    if (post?.network === "bluesky") return BlueskyPreview;
    return null;
}
